import React, { createContext, useContext, useState } from 'react';

export type RunDetailStatus = 'done' | 'failed' | 'running';

export interface RunDetailRun {
  id: string;
  status: RunDetailStatus;
  startedAt: string;
  finishedAt?: string;
  durationSec?: number;
  notes?: string;
}

export interface RunDetailExecution {
  tool: string;
  action: string;
  result: string;
  status: string;
}

export type RunDetailKind = 'chat' | 'command' | 'routine';

export interface RunDetailPanel {
  run: RunDetailRun;
  execs: RunDetailExecution[] | null;
  exeLoading: boolean;
  /** Which surface opened this panel — drives the sidebar title. Defaults to 'chat'. */
  kind?: RunDetailKind;
}

interface RunDetailPanelContextValue {
  runDetailPanel: RunDetailPanel | null;
  setRunDetailPanel: React.Dispatch<React.SetStateAction<RunDetailPanel | null>>;
}

const RunDetailPanelContext = createContext<RunDetailPanelContextValue>({
  runDetailPanel: null,
  setRunDetailPanel: () => {},
});

export const RunDetailPanelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [runDetailPanel, setRunDetailPanel] = useState<RunDetailPanel | null>(null);
  return (
    <RunDetailPanelContext.Provider value={{ runDetailPanel, setRunDetailPanel }}>
      {children}
    </RunDetailPanelContext.Provider>
  );
};

export const useRunDetailPanel = () => useContext(RunDetailPanelContext);
